<template>
  <v-app id="app">
    <router-view v-if="is_dashboard"></router-view>
    <Home v-else/>
  </v-app>
</template>
<script>

import Home from "./components/home/Home";
import router from '@/router'

export default {
  name: 'App',
  components: {
    Home,
  },
  data: () => ({
    is_dashboard: false,
  }),
  created(){
    this.is_dashboard = this.$router.currentRoute.matched.find(x=> 
      x.name == 'Dashboard')
  }  
};
</script>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-width: 400px;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.no-wrap{
  word-break: normal !important;
}
.note{
  white-space: pre-line;
}
.pointer{
  cursor: pointer;
}
</style>
